import { create } from "zustand";

/**
 * Tracks app-level overlays that must suppress unrelated full-screen prompts
 * (the PWA install prompt renders at z-index 9999999 and would cover a bottom
 * sheet). Not persisted.
 */
interface OverlayStore {
  /** Number of bottom sheets currently open. */
  openBottomSheets: number;
  registerBottomSheet: () => void;
  unregisterBottomSheet: () => void;
}

export const useOverlayStore = create<OverlayStore>()((set) => ({
  openBottomSheets: 0,
  registerBottomSheet: () =>
    set((state) => ({ openBottomSheets: state.openBottomSheets + 1 })),
  unregisterBottomSheet: () =>
    set((state) => ({
      openBottomSheets: Math.max(0, state.openBottomSheets - 1),
    })),
}));

export const useIsBottomSheetOpen = (): boolean =>
  useOverlayStore((state) => state.openBottomSheets > 0);
